import React from 'react';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import cn from 'classnames';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';

export interface SecondaryButtonLightBgProps {
  /**
   * Callback when the button is clicked
   */
  onClick: () => void;

  /**
   * Whether or not the button is disabled
   */
  disabled: boolean;

  /**
   * The label for the button
   */
  translatedContent: TranslatedContent;

  /**
   * The class name for the button
   */
  className?: string;

  /**
   * The icon for the button to be shown on the left
   */
  icon?: (props: {
    hovered: boolean;
    focused: boolean;
    active: boolean;
  }) => React.ReactNode | null;
}

export const SecondaryButtonLightBg = ({
  translatedContent,
  onClick,
  disabled,
  className,
  icon,
}: SecondaryButtonLightBgProps) => {
  return (
    <TouchTarget
      className={cn('inline-block max-w-full', className)}
      disabled={disabled}
      behavior={{
        type: 'onClick',
        onClick: () => {
          onClick();
        },
      }}
      content={({ hovered, focused, active }) => {
        return (
          <div
            className={cn(
              `flex w-full text-center items-center rounded h-[40px] px-6 border-box transition-colors whitespace-nowrap select-none border-[1.5px] gap-2.5`,
              {
                'cursor-pointer border-royal-900': !disabled,
                'cursor-not-allowed border-gray-200': disabled,
                'bg-white': disabled || (!hovered && !focused && !active),
                'bg-royal-100': !disabled && (hovered || focused),
                'bg-royal-300': !disabled && active,
              },
            )}
          >
            {icon && icon({ hovered, focused, active })}
            <S2Typography
              as={'span'}
              translatedContent={translatedContent}
              variant={'headline-6-alt'}
              textColorVariant={disabled ? 'gray-400' : 'royal-900'}
              truncate={true}
              flex={true}
            />
          </div>
        );
      }}
    />
  );
};
